import React from "react";
import Developments from './developments'
import DevelopmentPro from './developmentsPro'
// import Breadcrumbs from "../breadcrumbs";
import { graphql, useStaticQuery } from 'gatsby';


export default function AboutDevelopments(props) {

    const {realEstate} = useStaticQuery(graphql`
        query {
            realEstate {
                template_version
                name
                proFeatures{
                    levelProyect
                }
                sections {
                    developments {
                        about {
                            title
                        }
                    }
                }
            }
        }`
    )

    const {template_version,proFeatures} = realEstate
    const MediaPro = template_version === 'PRO' ? true : false;
    const {levelProyect} = proFeatures
    const {tag} = props
    
  return (
    <article>
        <section class="development-about pb-2">
            {/* <div class="container-fluid">
                <div class="row">
                    <div className="col-lg-12">
                        <Breadcrumbs
                            props={[
                            { name: realEstate.name, route: "/", location: "" },
                            { name: "Emprendimientos", route:   "", location: ""},
                            ]}
                        />
                    </div>
                    <div class="col-lg-12">
                        <h1>
                            {realEstate.sections.developments.about.title} {MediaPro && tag ? <span className="text-capitalize"> - {tag}</span> : ''}
                        </h1>
                    </div>
                </div>
            </div> */}
            
            {levelProyect && !tag
                ? <DevelopmentPro />
                : <Developments tag={tag} />
            }
            
        </section>
    </article>
  )}
